//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[],[[["name","package_name","super_name"],"AddNewClass",{},3,0],[["name","package_name"],"RemoveClass",{},2,0],[["name","package_name","new_name"],"RenameClass",{},3,0],[["name"],"AddNewRule",{},1,0],[[],"RemoveRule",{},0,0],[["new_name"],"RenameRule",{},1,0],[[],"GetRulePath",{R_:{path:''}},0,0],[["path"],"SetRulePath",{},1,0],[[],"GetRuleLibraryPath",{R_:{path:''}},0,0],[["path"],"SetRuleLibraryPath",{},1,0],[[],"GetRulePriority",{R_:{priority:''}},0,0],[["priority"],"SetRulePriority",{},1,0],[[],"GetRuleCondition",{R_:{condition:''}},0,0],[["condition"],"SetRuleCondition",{},1,0]],[]];
SPLM.CAM.Teaching = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.Teaching";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;